import React from 'react';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader';

import ListingPageContainer from './components/ListingPage/ListingPageContainer';

import {ExperimentProvider} from '@homeaway/react-experiment';

function Root({store, listingPageComponent}) {
    const abacus = store.getState().abacusTestsReducer;

    return (
        <Provider store={store}>
            <ExperimentProvider abacus={abacus}>
                <ListingPageContainer listingPageComponent={listingPageComponent}/>
            </ExperimentProvider>
        </Provider>
    );
}

export default hot(module)(Root);
